(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks', [
        'uwAgenda.help',
        'uwAgenda.global',
        'ngTouch'
    ]);
    module.constant('TaskBroadcast', {
        "RefreshFilter": "task:filter"        
    });
    module.constant('TaskStateEnum', {
        "InProgress": { name: "InProgress", value: 0 },
        "Finished": { name: "Finished", value: 1 },
        "FollowUpByOperator": { name: "FollowUpByOperator", value: 2 },
        "FollowUpByRingfoon": { name: "FollowUpByRingfoon", value: 3 }
    });
    module.constant('FlagTypeEnum', {
        "Move": { name: "Move", color: "yellow", value: 0, selected: false },
        "Good": { name: "Good", color: "green-soft", value: 1, selected: false },
        "Warning": { name: "Warning", color: "yellow-casablanca", value: 2, selected: false },
        "Info": { name: "Info", color: "blue-steel", value: 3, selected: false }
    });

    /* task config function */
    module.config(['$stateProvider', 'HelpCategoryEnum', function TasksConfig($stateProvider, HelpCategoryEnum) {
        $stateProvider
            .state('Home.Tasks', {
                url: 'Tasks/:isToDo/:all?states&taskId',
                templateUrl: '/app/tasks/templates/tasks-overview.template.html',
                controller: 'TasksOverviewController',
                controllerAs: 'vm',
                resolve: {
                    tasks: ['$stateParams', 'TaskService', 'SharedAgendaService', 'DateService', function ($stateParams, TaskService, SharedAgendaService, DateService) {
                        return TaskService.query(SharedAgendaService.currentUser().id, $stateParams.isToDo, DateService.data.date, $stateParams.all);
                    }],
                    title: ['$stateParams', function ($stateParams) {
                        if ($stateParams.isToDo === 'true') {
                            $stateParams.helpCategory = HelpCategoryEnum.UrgentTodo.value;
                        }
                        else {
                            $stateParams.helpCategory = HelpCategoryEnum.TaskGeneral.value;
                        }

                        return $stateParams.isToDo === 'true' ? 'task_header_urgent_todo' : 'task_header_day_task';
                    }],
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Tasks',
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/todo-2.min.css'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true                   
                },
                params: {
                    helpCategory: null,
                    isToDo: 'false'
                },
                ncyBreadcrumb: {
                    label: "{{vm.title | translate}}"                    
                }
            });
    }]);


})();